import React, { Fragment, useState } from "react";
import { Router, Switch, Redirect } from "react-router-dom";
import { Container } from "reactstrap";
import PrivateRoute from "./components/PrivateRoute";
import Loading from "./components/Loading";
import LoadingBar from "./components/LoadingBar";
import NavBar from "./components/Navbar";
import Footer from "./components/Footer";
//import { Footer } from './components/layout-components';
import TenantSelector from "./views/admin/TenantList";
import Backoffice from "./routes/Backoffice";
import Admin from "./routes/Admin";
import Tenant from "./routes/Tenant";
import Centrale from "./routes/Centrale"
import Collaudo from "./routes/Collaudo";
import { useAuth0 } from "./auth/react-auth0-wrapper";
import Growl from "./components/Growl";
import history from "./utils/history";
import roles from "./auth/roles";
import { debounce } from "lodash";
import { Sidebar } from './components/layout-components';
import { Provider } from 'react-redux';
import configureStore from './components/configureStore';

// fontawesome
import initFontAwesome from "./utils/initFontAwesome";
initFontAwesome();

const roots = {
  ADMIN: "/admin",
  BACKOFFICE: "/backoffice",
  COLLAUDO: "/collaudo",
  DEALER: "/tenant",
  CENTRALE: "/centrale",
  MARKETING: "/marketing",
  DASHBOARD: "/dashboard"
};

const App = ({ eventBus }) => {

  const [margin, setMargin] = React.useState("5rem");
  const { loading, user, isAuthenticated } = useAuth0();

  const [isOpen, setOpen] = useState(true)

  const toggle = () => setOpen(!isOpen)

  const setMarginToNavbar = () => {
    const navbarContainer = document.querySelector("#topNavbar");
    if (!navbarContainer) return;
    const height = `${navbarContainer.offsetHeight + 10}px`;
    setMargin(height);
  };

  const resizeCallback = debounce(setMarginToNavbar, 300);

  React.useEffect(() => {
    if (isAuthenticated) {
      setMarginToNavbar();
      window.addEventListener("resize", resizeCallback);
      return () => {
        window.removeEventListener("resize", resizeCallback);
      };
    }
  }, [loading]);

  const getHomeView = () => {
    if (!user) return null;
    const role = user.getRole();
    if (
      [
        roles.ADMIN,
        roles.AGENTE,
        roles.DEALER,
        roles.VENDITORE,
        roles.BACKOFFICE
      ].includes(role)
    ) {
      return TenantSelector;
    } else if (role === roles.SERVICE) {
      return () => <Redirect to="/tenant/services" />;
    } else if (role === roles.MARKETING) {
      return () => <Redirect to="/tenant/marketing" />;
    } else if (role === roles.COLLAUDO) {
      return () => <Redirect to="/collaudo/list" />;
    } else if (role === roles.CENTRALE) {
      return () => <Redirect to="/centrale/tickets" />;
    } else {
      return () => <div>Errore utente senza ruolo valido</div>;
    }
  };

  if (loading) {
    return <Loading />;
  }

  const store = configureStore();

  return (
    <Provider store={store}>

      <Router history={history}>
        <Growl eventBus={eventBus} />
        <LoadingBar />

        <Fragment>
          <div className="app-wrapper app-sidebar-fixed app-header-fixed app-footer-fixed">

            <div>
              {isAuthenticated && <Sidebar />}
            </div>

            <div className="app-main">

              {isAuthenticated && <NavBar id="topNavbar" roots={roots} />}

              <div className="app-content">
                <div className="app-content--inner mb-4" style={{ padding: "0rem" }}>
                  <div className="app-content--inner__wrapper mb-4">
                    <Container
                      id="mainContainer"
                      className="flex-grow-1"
                    >
                      <Switch>
                        <PrivateRoute path="/" exact component={getHomeView()} />
                        <PrivateRoute path="/unhauthorized" exact component={() => <p>Non sei autorizzato ad accedere a questa pagina!</p>} />
                        <PrivateRoute
                          path={roots.ADMIN}
                          component={Admin}
                          roles={[roles.ADMIN]}
                        />
                        <PrivateRoute
                          path={roots.BACKOFFICE}
                          component={Backoffice}
                          roles={[roles.ADMIN]}
                        />
                        <PrivateRoute
                          path={roots.DEALER}
                          component={Tenant}
                          roles={[
                            roles.ADMIN,
                            roles.BACKOFFICE,
                            roles.MARKETING,
                            roles.AGENTE,
                            roles.VENDITORE,
                            roles.SERVICE,
                            roles.DEALER
                          ]}
                        />
                        <PrivateRoute
                          path={roots.COLLAUDO}
                          component={Collaudo}
                          roles={[
                            roles.ADMIN,
                            roles.COLLAUDO
                          ]}
                        />
                        <PrivateRoute
                          path={roots.CENTRALE}
                          component={Centrale}
                          roles={[
                            roles.ADMIN,
                            roles.CENTRALE
                          ]}
                        />
                      </Switch>
                    </Container>
                  </div>
                </div>

                {isAuthenticated && <Footer />}

              </div>

            </div>

          </div>
        </Fragment>

      </Router>
    </Provider>
  );
};

export default App;
